import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Event as NavigationEvent,Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Item, Blobs, UrlService, ItemsService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-items-details',
  templateUrl: './items-details.component.html',
  styleUrls: ['./items-details.component.scss']
})
export class ItemsDetailsComponent implements OnInit {
  id: string;
  item: Observable<Item>;
  blobs:Observable<Blobs[]>;
  url: string;
  constructor(
    private router :Router,
    private urlservice: UrlService,
    private db: AngularFirestore,
    private itemsservice: ItemsService,
    private storage:AngularFireStorage,
    private route: ActivatedRoute
  ) {  
    }
    onDelete(b:Blobs){
b.refFirestore.delete().then(()=>{
  this.storage.ref(b.fullPath).delete();
});
    }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.item = this.itemsservice.details(this.id);
    this.blobs= this.db.collection('item')
    .doc(this.id)
    .collection<Blobs>('blobs', ref => ref.orderBy('id').where('type', '==', 'item'))
.valueChanges();
this.router.events
    .subscribe(
      (event: NavigationEvent) => {
        if(event instanceof NavigationEnd) {
          this.urlservice.send(event.url);
  
        }
      });
  }

}
